import { Dow } from "../../generated/graphql";

/**
 * Formats day enum values to readable day names
 * @param day - DOW enum value (can be uppercase or lowercase)
 * @returns Formatted day name or null if invalid
 */
export const formatDay = (day?: string | null): string | null => {
  if (!day) return null;
  
  // Convert to uppercase as our frontend expects uppercase enum values
  const upperDay = day.toUpperCase() as Dow;
  
  switch (upperDay) {
    case Dow.Mon: return "Monday";
    case Dow.Tue: return "Tuesday";
    case Dow.Wed: return "Wednesday";
    case Dow.Thu: return "Thursday";
    case Dow.Fri: return "Friday";
    case Dow.Sat: return "Saturday";
    case Dow.Sun: return "Sunday";
    default: return null;
  }
};

/**
 * Gets the short form of a day name (3 letters)
 * @param day - DOW enum value (can be uppercase or lowercase)
 * @returns Short day name or null if invalid
 */
export const formatDayShort = (day?: string | null): string | null => {
  if (!day) return null;
  
  // Convert to uppercase as our frontend expects uppercase enum values
  const upperDay = day.toUpperCase() as Dow;
  
  switch (upperDay) {
    case Dow.Mon: return "Mon";
    case Dow.Tue: return "Tue";
    case Dow.Wed: return "Wed";
    case Dow.Thu: return "Thu";
    case Dow.Fri: return "Fri";
    case Dow.Sat: return "Sat";
    case Dow.Sun: return "Sun";
    default: return null;
  }
};